import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import CreateMaintenanceHeader from "./components/CreateMaintenanceHeader";
import CreateMaintenanceForm from "./components/CreateMaintenanceForm";

import useCustomSelector from "@redux/hooks/useCustomSelector";

import { ROUTES } from "@constants/routes";
import { ErrorModal, SuccessModal } from "@components";

export default function CreateMaintenance() {
  const navigate = useNavigate();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { createSuccess, createError } = useCustomSelector(
    (store) => store.inventory.maintenanceState,
  );

  const createSuccessAction = () => {
    navigate(`${ROUTES.INVENTORY.MAINTENANCE}`);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  useEffect(() => {
    if (createSuccess) {
      setIsSuccessModalOpen(true);
    }
    if (createError) {
      setIsErrorModalOpen(true);
    }
  }, [createSuccess, createError]);

  return (
    <div className="p-10">
      <CreateMaintenanceHeader />
      <CreateMaintenanceForm />

      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
          subtitle="You have requested for maintenance"
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
    </div>
  );
}
